import { createFileRoute } from "@tanstack/react-router";
import AdminBrukere from "../../../../pages/AdminBrukere";

export const Route = createFileRoute("/_app/account/admin/brukere")({
	component: AdminBrukere,
});
